export const LOCAL_STORAGE_FLAGS = {
    READY_MODULE_SKIP_FTUE_INTRO: 'ready_module_skip_FTUE_intro'
}
// A finite state machine pattern implementation,
// all possible pre check machine states are predefined here.
export const PRE_CHECK_MACHINE_STATES = {
    init: "PRE_CHECKS_INIT",
    networkPingChecks: "NETWORK_PING_CHECKS",
    networkSpeedChecks: "NETWORK_SPEED_CHECKS",
    hardwareChecks: "HARDWARE_CHECKS",
    studentSpeechVolumeChecks: "STUDENT_SPEECH_VOLUME_CHECKS",
    studentASRChecks: "STUDENT_SPEECH_ASR_CHECKS",
    end: "PRE_CHECKS_ENDED"
}

// All items to be checked.
export const CHECKED_ITEMS = [
    PRE_CHECK_MACHINE_STATES.networkSpeedChecks,
    PRE_CHECK_MACHINE_STATES.networkPingChecks,
    PRE_CHECK_MACHINE_STATES.hardwareChecks,
    PRE_CHECK_MACHINE_STATES.studentSpeechVolumeChecks,
    PRE_CHECK_MACHINE_STATES.studentASRChecks
];

// All possible status for each checked items.
export const STUDENT_PRE_CHECK_STATUS = {
    unchecked: "UNCHECKED",
    pending: "PENDING",
    async_pending: "ASYNC_PENDING",
    success: "SUCCESS",
    failed: "FAILED"
  };

export const READY_MODULE_EVENTS = {
    WINDOW_TAB_HIDDEN: 'WINDOW_TAB_HIDDEN',
    WINDOW_TAB_RESUMED: 'WINDOW_TAB_RESUMED',
    HIT_ERROR_BOUNDARY: 'HIT_ERROR_BOUNDARY',
}

export const READY_MODULE_TEST_MODES = {
    SKIP: "SKIP",
    FTUE: "first_time_experience",
    RETURNED_USER_WITH_ASSESSMENTS: "returned_user_with_assessments",
    RETURNED_USER: "returned_user"
}